import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';


export const fetchAllTestimonials = createAsyncThunk(
  'alltestimonials/fetchAllTestimonials',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get('https://api.thevisaman.in/api/testimonials/all');
      return response.data.data; 
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Something went wrong');
    }
  }
);

const getTestimonialSlice = createSlice({
  name: 'alltestimonials',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllTestimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllTestimonials.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAllTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getTestimonialSlice.reducer;
